const Colors = {
  primary: "#087C6F",
  tint: "#FE6F1E",
};

export default Colors;
